class paymentMethods extends HTMLElement {
    constructor() {
      super();

      this.paymentMethods = this.querySelectorAll("[data-payment-method]") || [];;
      this.popin = this.querySelector("[data-popin]");
      this.popinContent = this.querySelector("[data-popin-content]");
      this.popinClose = this.popin?.querySelectorAll('[data-close-popin]') || [];
      this.klarnaContent = this.querySelector("[data-klarna-content]");
      this.afterpayContent = this.querySelector("[data-afterpay-content]");

      if(this.paymentMethods.length > 0) {
        this.paymentMethods.forEach( method => {
          method.addEventListener("click", () => {
            if(this.popin) {
              if(method.dataset.paymentMethod === "afterpay") {
                this.klarnaContent.style.display = "none";
                this.afterpayContent.style.display = "block";
              }else if(method.dataset.paymentMethod === "klarna") {
                this.klarnaContent.style.display = "block";
                this.afterpayContent.style.display = "none";
              }
              this.openPopin(this.popin, this.popinContent);
            }
          });
        });
      }

      if(this.popinClose.length > 0) {
        this.popinClose.forEach( close => {
          close.addEventListener("click", () => {
            if(this.popin && this.popinContent) {
              this.closePopin(this.popin, this.popinContent);
            }
          });
        });
      }

      this.popin.addEventListener("click", (event) => {
        event.stopPropagation();
        if(this.popin && this.popinContent && event.target === this.popin) {
         this.closePopin(this.popin, this.popinContent);
        }
      }); 

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" || event.key === "Esc") { 
          if(this.popin && this.popinContent) {
              this.closePopin(this.popin, this.popinContent);
            }
        }
      });

    }

    openPopin(popin, popinContent) {
      document.body.appendChild(this.popin);
      popin.classList.add("visible");

      if(popinContent) {
        setTimeout( () => {
          popinContent.classList.add('animated');
        }, 50)
      }
    }

    closePopin(popin, popinContent) {
        popin.classList.remove("visible");
        this.appendChild(popin);
        if(popinContent) {
          popinContent.classList.remove('animated');
        }
    }

  }

  window.customElements.define("payment-methods", paymentMethods);